var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "videoStyle" },
    [
      _c("h2", [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c(
        "el-form",
        { attrs: { "label-width": "80px", model: _vm.datas, size: "small" } },
        [
          _c("el-form-item", { attrs: { label: "视频源" } }, [
            _c(
              "div",
              { staticClass: "upload-area" },
              [
                _c("input", {
                  ref: "videoInput",
                  staticStyle: { display: "none" },
                  attrs: { type: "file", accept: "video/*" },
                  on: { change: _vm.handleVideoChange },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "video-preview",
                    on: { click: _vm.handleVideoClick },
                  },
                  [
                    _vm.datas.videoSrc
                      ? _c("video", {
                          staticClass: "preview-video",
                          attrs: { src: _vm.resPath + _vm.datas.videoSrc },
                        })
                      : _c("div", { staticClass: "video-placeholder" }, [
                          _c("i", { staticClass: "el-icon-video-camera" }),
                          _vm._v(" "),
                          _c("p", [_vm._v("点击上传视频")]),
                        ]),
                  ]
                ),
                _vm._v(" "),
                _vm.datas.videoSrc
                  ? _c(
                      "el-button",
                      {
                        staticClass: "clear-btn",
                        attrs: { type: "text", icon: "el-icon-delete" },
                        on: { click: _vm.clearVideo },
                      },
                      [_vm._v("清除视频")]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "upload-tip" }, [
              _vm._v("视频格式：mp4/webm，建议不超过 50MB"),
            ]),
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "背景图" } }, [
            _c(
              "div",
              { staticClass: "upload-area" },
              [
                _c("input", {
                  ref: "bgInput",
                  staticStyle: { display: "none" },
                  attrs: { type: "file", accept: "image/*" },
                  on: { change: _vm.handleBgChange },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "poster-preview",
                    on: { click: _vm.handleBgClick },
                  },
                  [
                    _vm.datas.bgSrc
                      ? _c("img", {
                          staticClass: "preview-img",
                          attrs: { src: _vm.resPath + _vm.datas.bgSrc },
                        })
                      : _c("div", { staticClass: "image-placeholder" }, [
                          _c("i", { staticClass: "el-icon-picture-outline" }),
                          _vm._v(" "),
                          _c("p", [_vm._v("点击上传背景")]),
                        ]),
                  ]
                ),
                _vm._v(" "),
                _vm.datas.bgSrc
                  ? _c(
                      "el-button",
                      {
                        staticClass: "clear-btn",
                        attrs: { type: "text", icon: "el-icon-delete" },
                        on: { click: _vm.clearBg },
                      },
                      [_vm._v("清除背景")]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "upload-tip" }, [
              _vm._v("图片格式：jpg/png，大小≤5MB，建议尺寸与视频比例一致"),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "自动播放" } },
            [
              _c("el-switch", {
                model: {
                  value: _vm.datas.autoplay,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "autoplay", $$v)
                  },
                  expression: "datas.autoplay",
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "field-tip" }, [
                _vm._v("开启自动播放时将默认静音（浏览器限制）"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "控制条" } },
            [
              _c("el-switch", {
                model: {
                  value: _vm.datas.controls,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "controls", $$v)
                  },
                  expression: "datas.controls",
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "field-tip" }, [
                _vm._v("关闭后用户无法手动播放/暂停"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "视频宽度" } },
            [
              _c("el-input-number", {
                attrs: {
                  min: 0,
                  max: 750,
                  step: 1,
                  placeholder: "0",
                  size: "small",
                },
                model: {
                  value: _vm.datas.videoWidth,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "videoWidth", $$v)
                  },
                  expression: "datas.videoWidth",
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "unit-tip" }, [
                _vm._v(_vm._s(_vm.widthUnitTip)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "field-tip" }, [
                _vm._v("设置背景图后此值按百分比计算，未设置时按照像素px"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "视频高度" } },
            [
              _c("el-input-number", {
                attrs: {
                  min: 0,
                  max: 750,
                  step: 1,
                  placeholder: "0",
                  size: "small",
                },
                model: {
                  value: _vm.datas.videoHeight,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "videoHeight", $$v)
                  },
                  expression: "datas.videoHeight",
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "unit-tip" }, [
                _vm._v(_vm._s(_vm.heightUnitTip)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "field-tip" }, [
                _vm._v("设置背景图后此值按百分比计算，未设置时按照像素px"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "上边距" } },
            [
              _c("el-input-number", {
                attrs: {
                  min: 0,
                  max: 100,
                  step: 1,
                  placeholder: "0",
                  size: "small",
                },
                model: {
                  value: _vm.datas.marginTop,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "marginTop", $$v)
                  },
                  expression: "datas.marginTop",
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "unit-tip" }, [_vm._v("%")]),
              _vm._v(" "),
              _c("span", { staticClass: "field-tip" }, [
                _vm._v("视频相对容器的上偏移（背景图不动）"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "左边距" } },
            [
              _c("el-input-number", {
                attrs: {
                  min: 0,
                  max: 100,
                  step: 1,
                  placeholder: "0",
                  size: "small",
                },
                model: {
                  value: _vm.datas.marginLeft,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "marginLeft", $$v)
                  },
                  expression: "datas.marginLeft",
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "unit-tip" }, [_vm._v("%")]),
              _vm._v(" "),
              _c("span", { staticClass: "field-tip" }, [
                _vm._v("视频相对容器的左偏移（背景图不动）"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }